module.exports = __webpack_public_path__ + "img/18a001-09.655be436.jpg";